import { Component, effect, Input, OnInit } from "@angular/core";
import { CommonModule, NgClass, NgIf } from "@angular/common";
import { MatCardModule } from "@angular/material/card";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";

import { DirectSessionLogicService } from "../../../../shared/direct-session-logic.service";
import { KnownSteps, Session, TrimmedSession } from "../../../../shared/models/session.model";


@Component({
  selector: "app-navigation-title-container",
  template: `

  <div class="breadcrumb-container col d-flex">
    @if(thisStep.index <= currentStep){
      <div [ngClass]="isMobile? 'breadcrumb-text-mobile':'breadcrumb-text'" >
        <div [ngClass]="thisStep.index < currentStep? 'circle-large-filled':'circle-large-empty'">
          <img *ngIf="step < currentStep" 
            [ngClass]="isMobile? 'icon-check':'icon-check-large'"
            src="assets/Icons/check.svg" alt="checkmark" 
          />
        </div>
  
        <div >{{thisStep.breadcrumbName}}</div>
  
        @if(breadrumbSpacer){
          <div class="breadcrumb-spacer">
            @if(!isMobile){
              <svg class="breadcrumb-spacer">
              <rect width="20" height="2" fill="white"/>
              </svg>
            }
            @if(isMobile){
              <svg class="breadcrumb-spacer">
              <rect width="5" height="2" fill="white"/>
              </svg>
            }
          </div>
        }
        
      </div>
    }

    @if(thisStep.index > currentStep){
      <div [ngClass]="isMobile? 'breadcrumb-text-mobile':'breadcrumb-text'" >
        <div class="circle-empty"></div>
        <div class="otherPage">{{thisStep.breadcrumbName}}</div>
        @if(breadrumbSpacer){
          <div class="breadcrumb-spacer">
            @if(!isMobile){
              <svg class="breadcrumb-spacer">
              <rect width="20" height="2" fill="white"/>
              </svg>
            }
            @if(isMobile){
              <svg class="breadcrumb-spacer">
              <rect width="5" height="2" fill="white"/>
              </svg>
            }
          </div>
        }
      </div>
    }

    
  </div>

  `,
  styleUrls: ['./navigation-title-container.component.scss'],
  standalone: true,
  imports: [MatCardModule, CommonModule, NgIf, NgClass]
})

export class NavigationTitleContainerComponent implements OnInit {
  // @Input() step!: KnownSteps;
  @Input() step!: number;
  breadrumbSpacer: boolean = true;

  isMobile: boolean = false;
  isCurrentStep: boolean = false;

  thisStep: KnownSteps = {} as KnownSteps;

  constructor(    
    public directSessionLogic: DirectSessionLogicService,
    public responsive: BreakpointObserver
  ) {

    effect(() => {
      let attempt = this.directSessionLogic.currentStepSignal();
      this.thisStep = this.directSessionLogic.knownStepsListSignal()[this.step];
      this.breadcrumbSpacerChecker();
    });

    this.breadcrumbSpacerChecker();
  }

  get session(): TrimmedSession {
    return this.directSessionLogic.trimmedSessionSignalValue;
  }
  get currentStep(): number {
    return this.directSessionLogic.currentStepSignal();
  }
  get stepIndex(): number {
    return this.directSessionLogic.currentStepSignal();
  }
  get maxStep(): number {
    return this.directSessionLogic.knownStepsListSignal().length -1;
  }

  ngOnInit(): void {
    this.responsive.observe([
      Breakpoints.Small,Breakpoints.XSmall
        ])
        .subscribe(result => {
          this.isMobile = false; 
          if (result.matches) 
            this.isMobile = true;      
    });

    this.isActiveStep();
  }

  ngOnChanges() {
    this.isActiveStep();
  }

  isActiveStep() {
    if (this.step === this.stepIndex) {
      this.isCurrentStep = true;
    }else{
      this.isCurrentStep = false; 
    }
  }

  redirectToBreadcrumbStep(stepRef: string) { 
    this.directSessionLogic.redirectToStepSignal("/"+stepRef)
  }

  async breadcrumbSpacerChecker(){
    if (this.step === this.maxStep) {
      this.breadrumbSpacer = false;
    }
  }

}
